<template>
    <div>
        <modal :show.sync="show_modal" :hide-footer="true">
            <div v-if="approval && approval.approval_type === 'PROPTY_APPROVAL'" style="min-width: 500px !important;">
                <div>
                    <h3 class="mb-3">{{ approval.appr_content }}</h3>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th class="bg-dark text-white py-2" width="150px">Case</th>
                                <td class="py-2">#{{ approval.appr_req_value.prod_id }}</td>
                            </tr>
                            <tr>
                                <th class="bg-dark text-white py-2">Customer</th>
                                <td class="py-2">{{ approval.appr_req_value.prod_customer_name }}</td>
                            </tr>
                            <tr>
                                <th class="bg-dark text-white py-2">Project</th>
                                <td class="py-2">{{ approval.appr_req_value.product_detail.prod_pm_project_name }}</td>
                            </tr>
                            <tr>
                                <th class="bg-dark text-white py-2">Unit No</th>
                                <td class="py-2">{{ approval.appr_req_value.product_detail.prod_pm_unit_no }}</td>
                            </tr>
                            <tr>
                                <th class="bg-dark text-white py-2">SPA Price</th>
                                <td class="py-2">RM {{ approval.appr_req_value.product_detail.prod_pm_spa_price | moneyFormatter }}</td>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div v-if="!is_view_mode">
                    <div class="my-4">
                        <b-form-textarea
                            id="textarea"
                            v-model="remark"
                            placeholder="Add a remark"
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                    </div>
                    <div class="d-flex justify-content-between">
                        <el-button class="bg-danger py-2 px-3 text-white" 
                        :loading="is_loading_review"
                        @click="submitReview(approval, approval.next_approval_reviewers, 0)"
                        ><i class="fa fa-times mr-1"></i>Reject
                        </el-button>
                        <el-button class="bg-success py-2 px-3 text-white" 
                            :loading="is_loading_review"
                            @click="submitReview(approval, approval.next_approval_reviewers, 1)"
                            ><i class="fa fa-check mr-1"></i>Approve
                        </el-button>
                    </div>
                </div>
            </div>
        </modal>  
    </div>
</template>
<script>
    import { Button } from 'element-ui'
    import { useAuthStore } from '@/stores/authStore'
    import { useCustomerStore } from '@/stores/customerStore'
    import { useProductStore } from '@/stores/productStore'
		import { useNotificationStore } from '@/stores/notificationStore'
    import { useMessagingStore } from '@/stores/messagingStore'
    import { useHestiaStore } from '@/stores/hestiaStore'
		import { mapActions, mapState } from 'pinia'
    import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'

    export default {
        props: ['approval'],
        mixins: [notifyFunctionMixin],
        components: {
            [Button.name]: Button,
        },
        data() {
            return {
                is_loading_review: false,
                show_modal: false,
                remark: '',
                is_view_mode: false,
            }
        },
        methods: {
					...mapActions(useNotificationStore, ['createNotification','fetchEmailTemplate']),
					...mapActions(useCustomerStore, ['getCustomer']),
          ...mapActions(useMessagingStore, ['sendEmail']),
          ...mapActions(useProductStore, ['updateProduct']),
					toggleView(is_view_mode = null) {
							if(is_view_mode !== null){
									this.is_view_mode = is_view_mode
							}
							this.show_modal = !this.show_modal;
					},
					async submitReview(approval, next_reviewers, val){
						const reviewer = next_reviewers?.find(
							(item) => Number(item.appr_rev_user_id) === Number(this.auth_user.id)
						)
						if (!reviewer) {
							return
						}

						this.is_loading_review = true
						const data = {
							appr_rev_remark: this.remark,
							appr_rev_status: val,
						}

						try {
							const res = await axios.put(
								services.approval + 'approval_reviewers/' + reviewer.appr_rev_id,
								data,
								{ headers: getHeader() }
							)

							const updated = await this.updateProduct(approval.appr_related_id, {
								prod_approval_id: approval.approval_id,
							})
							if (_gHlp.isEmpty(updated)) {
								return
							}

							this.remark = ''
							this.notifySuccess('<b>Approval: - Successfully Reviewed.')
							this.$emit('refresh-approval')
							this.show_modal = false

							if (!_gHlp.isEmpty(res.data) && !_gHlp.isEmpty(res.data.data)) {
								const apvData = res.data.data
								if (
									apvData.appr_final_status === 0 &&
									apvData.approval_type === 'PROPTY_APPROVAL' &&
									val === 0
								) {
									const productData = apvData.appr_final_value || this.approval.appr_req_value
									if (
										productData &&
										productData.product_detail &&
										productData.product_detail.prod_pm_property_src === 'HESTIA' &&
										productData.product_detail.prod_pm_unit_id
									) {
										try {
											await useHestiaStore().updateHestiaUnitStatus(
												productData.product_detail.prod_pm_unit_id,
												'OPEN'
											)
										} catch (e) {
											console.error('Failed to update Hestia unit status to Open:', e)
										}
									}
								}
								this.sendNotifFinalApproval(apvData, res.data.message)
							}
						} catch (e) {
							this.errorFunction(e)
						} finally {
							this.is_loading_review = false
						}
					},
          async sendCaseCreatedEmail(apvData) {
              if(apvData.appr_final_status !== 1){
                  return;
              }
              
              const emailTemplate = await this.fetchEmailTemplate('CASE_CREATED');
              if (emailTemplate) {
                  const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

                  // Prepare the email data
                  const emailData = {
                      to: recipients,
                      subject: emailTemplate.notif_temp_title,
                      body: emailTemplate.notif_temp_message
                          .replace('{case_id}', apvData.appr_related_id) // Replace {case_id} with case ID
                          .replace('{case_name}', apvData.appr_final_value.prod_customer_name), // Replace {case_name} with customer name
                  };

                  try {
                      await this.sendEmail(emailData);
                      this.notifySuccess({ notif_temp_type: 'success', notif_temp_title: 'Success', notif_temp_message: 'Case Created email sent successfully' });
                  } catch (error) {
                      console.error('Failed to send case created email:', error);
                      this.notifyError({ notif_temp_type: 'error', notif_temp_title: 'Error', notif_temp_message: 'Failed to send case created email' });
                  }
              }
          },
					async sendNotifFinalApproval(apvData,message){
						if(apvData.appr_final_status !== 1){
							return;
						}
						
						if(['MTG_APPROVAL','PROPTY_APPROVAL','PL_APPROVAL','INS_APPROVAL','REF_APPROVAL','OTH_LOAN_APPROVAL'].includes(apvData.approval_type)){
							let contentNotification = {
								noti_message: "CASE #"+ apvData.appr_related_id +" : "+message,
								noti_url: window.location.origin + '/casesListings',
								microservice_code: 'product',
								noti_related_type: 'product',
								noti_related_id: apvData.appr_related_id
							}
							if(_gHlp.isEmpty(apvData.appr_final_value.prod_customer_id)) return false;
							//GET DETAIL CUSTOMER
							const customer = await this.getCustomer(apvData.appr_final_value.prod_customer_id);
							if(!_gHlp.isEmpty(customer)){
								//TO SE
								let notification = { ...contentNotification, noti_user_id: customer.se.id }
								this.createNotification(notification)

								//TO SSE
								if(!_gHlp.isEmpty(customer.sse)){
									notification = { ...contentNotification, noti_user_id: customer.sse.id }
									this.createNotification(notification)
								}
								
								//TO SSA
								if(!_gHlp.isEmpty(customer.ssa)){
									notification = { ...contentNotification, noti_user_id: customer.ssa.id }
									this.createNotification(notification)
								}
                await this.sendCaseCreatedEmail(apvData);
							}
						}

					}
        },
        computed:{
            ...mapState(useAuthStore, ['auth_user'])
        },
    }
</script>